export default __webpack_public_path__ + "static/22-0510f045c76d0aa99d3215ba7a07e059.png";